import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 企业管理
 */
export default {
  path: 'enterprise',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '企业管理',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value, menuName: '个人认证' }
  ],
  platformAlias: [],
  applicableCompanyIdentities: workbenchServiceDict.array.map(
    dict => dict.value
  ),
  roles: [
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
    platformFunctionModuleDict.DEFAULT.right
  ],
  superviseInstitutions: [],

  children: [
    // 首页
    {
      path: 'home',
      name: 'CompanyHome',
      component: '/enterprise-views/home',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '首页',
        icon: 'icon-side_enterprise_home'
      },
      applicableCompanyTypes: companyTypeDict.array.map(dict => {
        return { companyType: dict.value }
      }),
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 企业认证
    {
      path: 'certificate',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '企业认证',
        hidden: true,
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: companyTypeDict.array.map(dict => {
        return { companyType: dict.value }
      }),
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: [],

      children: [
        // 认证信息
        {
          path: 'info',
          name: 'EnterpriseCertificateInfo',
          component: '/enterprise-views/certificate/info',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '认证信息',
            hidden: true
          },
          applicableCompanyTypes: companyTypeDict.array.map(dict => {
            return { companyType: dict.value }
          }),
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 认证流程
        {
          path: 'process/:edit?',
          name: 'EnterpriseCertificateProcess',
          component: '/enterprise-views/certificate/process',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '认证流程',
            hidden: true
          },
          applicableCompanyTypes: companyTypeDict.array.map(dict => {
            return { companyType: dict.value }
          }),
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        }
      ]
    },

    // 服务开通
    {
      path: 'service/:identity/process',
      name: 'ServiceDredge',
      component: '/enterprise-views/audit/service-dredge',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '服务开通',
        hidden: true
      },
      applicableCompanyTypes: companyTypeDict.array.map(dict => {
        return { companyType: dict.value }
      }),
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 绑卡申请
    {
      path: 'tied-card',
      name: 'TiedCard',
      component: '/enterprise-views/tied-card',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '绑卡申请',
        hidden: true
      },
      applicableCompanyTypes: companyTypeDict.array.map(dict => {
        return { companyType: dict.value }
      }),
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 开户信息
    {
      path: 'account-info',
      name: 'AccountInfo',
      component: '/enterprise-views/account-info',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '开户信息',
        hidden: true
      },
      applicableCompanyTypes: companyTypeDict.array.map(dict => {
        return { companyType: dict.value }
      }),
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 组织架构
    {
      path: 'department',
      name: 'Department',
      component: '/enterprise-views/department',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '组织架构',
        icon: 'icon-side_enterprise_department'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
        platformFunctionModuleDict.DEFAULT.right
      ],
      superviseInstitutions: []
    },

    // 员工管理
    {
      path: 'employee',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '员工管理',
        icon: 'icon-side_employee',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
        platformFunctionModuleDict.DEFAULT.right
      ],
      superviseInstitutions: [],

      children: [
        // 员工列表
        {
          path: 'platform',
          name: 'Employee',
          component: '/enterprise-views/employee',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '员工列表'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
            platformFunctionModuleDict.DEFAULT.right
          ],
          superviseInstitutions: []
        },

        // 商城权限
        {
          path: 'mall',
          name: 'MallEmployee',
          component: '/enterprise-views/employee/mall',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '商城权限'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 店铺权限
        {
          path: 'sell',
          name: 'SellEmployee',
          component: '/enterprise-views/employee/sell',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '店铺权限'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        }
      ]
    },

    // 企业资料
    {
      path: 'info',
      name: 'CompanyInfo',
      component: '/enterprise-views/info',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '企业资料',
        icon: 'icon-side_enterprise_info'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 门户管理
    {
      path: 'portal',
      name: 'Portal',
      component: '/enterprise-views/portal',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '门户管理',
        icon: 'icon-side_protal'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 证件管理
    {
      path: 'certificate-management',
      name: 'CertificateManagement',
      component: '/enterprise-views/certificate-management',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '证件管理',
        icon: 'icon-side_enterprise_certificate'
      },
      applicableCompanyTypes: companyTypeDict.array.map(dict => {
        return { companyType: dict.value }
      }),
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 模板管理
    {
      path: 'template',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '模板管理',
        icon: 'icon-side_enterprise_template',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: [],

      children: [
        // 公告模板（平台模板）
        {
          path: 'platform-notice',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '公告模板(平台模板)'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: [],

          children: [
            // 模板列表
            {
              path: 'list',
              name: 'TemplateNoticePlatform',
              component: '/enterprise-views/template/notice/platform',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '模板列表',
                cache: true,
                hidden: true,
                pageComponentName: 'TemplateNoticePlatform'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value,
                workbenchServiceDict.AGENCY.value
              ],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            },

            // 模板详情
            {
              path: ':templateId?/edit/:isCopy?/detail/:type?',
              name: 'TemplateNoticeEdit',
              component: '/enterprise-views/template/notice/enterprise/edit',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '模板详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value,
                workbenchServiceDict.AGENCY.value
              ],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            }
          ]
        },

        // 公告模板（企业模板）
        {
          path: 'enterprise-notice',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '公告模板(企业模板)'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: [],

          children: [
            // 模板列表
            {
              path: 'list',
              name: 'TemplateNoticeEnterprise',
              component: '/enterprise-views/template/notice/enterprise',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '模板列表',
                cache: true,
                hidden: true,
                pageComponentName: 'TemplateNoticeEnterprise'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value,
                workbenchServiceDict.AGENCY.value
              ],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            },

            // 编辑模板
            {
              path: ':templateId?/edit/:isCopy?/detail/:type?',
              name: 'TemplateNoticeEdit',
              component: '/enterprise-views/template/notice/enterprise/edit',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '编辑模板',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value,
                workbenchServiceDict.AGENCY.value
              ],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            }
          ]
        },

        // 品目模板
        {
          path: 'material',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '品目模板'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: [],

          children: [
            // 模板列表
            {
              path: 'list',
              name: 'TemplateMaterialList',
              component: '/enterprise-views/template/material/list',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '模板列表',
                cache: true,
                hidden: true,
                pageComponentName: 'TemplateMaterialList'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value,
                workbenchServiceDict.AGENCY.value
              ],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            },

            // 创建模板
            {
              path: 'form/:templateId?',
              name: 'TemplateMaterialForm',
              component: '/enterprise-views/template/material/form',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '创建模板',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value,
                workbenchServiceDict.AGENCY.value
              ],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 应用开通
    {
      path: 'app',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '应用开通',
        icon: 'icon-side_enterprise_app',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: [],

      children: [
        // 应用列表
        {
          path: 'list',
          name: 'AppList',
          component: '/enterprise-views/app-management/app-list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '应用列表',
            cache: true,
            hidden: true,
            pageComponentName: 'AppList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 开通应用（第一步）
        {
          path: ':appId?/open/first-step',
          name: 'AppOpenFirstStep',
          component: '/enterprise-views/app-management/app-open-first-step',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '开通应用',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 开通应用（第二步）
        {
          path: ':appId/open/second-step',
          name: 'AppOpenSecondStep',
          component: '/enterprise-views/app-management/app-open-second-step',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '开通应用',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 应用详情
        {
          path: ':appId/detail',
          name: 'AppDetail',
          component: '/enterprise-views/app-management/app-detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '应用详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        }
      ]
    },

    // 审批管理
    {
      path: 'workflow',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '审批管理',
        icon: 'icon-side_enterprise_workflow',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: [],

      children: [
        // 审批列表
        {
          path: 'list',
          name: 'WorkflowList',
          component: '/enterprise-views/workflow/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '审批列表',
            cache: true,
            hidden: true,
            pageComponentName: 'WorkflowList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 新增审批
        {
          path: ':definitionId?/create',
          name: 'WorkflowCreate',
          component: '/enterprise-views/workflow/create',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '新增审批',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        }
      ]
    },

    // 品目管理
    {
      path: 'material',
      name: 'MaterialManagementList',
      component: '/enterprise-views/material-management/material-list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '品目管理',
        icon: 'icon-side_fenleiguanli'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 项目交接
    {
      path: 'handover',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '项目交接',
        icon: 'icon-side_xiangmujiaojie',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: [],

      children: [
        // 招标采购
        {
          path: 'bidding',
          name: 'HandoverBiddingProcurement',
          component: '/enterprise-views/handover/bidding-procurement',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招标采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 代理采购
        {
          path: 'agent',
          name: 'HandoverAgent',
          component: '/enterprise-views/handover/agent',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '代理采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 投标报价
        {
          path: 'tender',
          name: 'HandoverTenderOffer',
          component: '/enterprise-views/handover/tender-offer',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '投标报价'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        },

        // 交接记录
        {
          path: 'record',
          name: 'HandoverRecordList',
          component: '/enterprise-views/handover/record-list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '交接记录'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: workbenchServiceDict.array.map(
            dict => dict.value
          ),
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: []
        }
      ]
    },

    // 系统访问统计
    {
      path: 'loginlog',
      name: 'EnterpriseLoginlog',
      component: '/enterprise-views/loginlog',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '系统访问统计',
        icon: 'icon-side_caigoushujukanban'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: workbenchServiceDict.array.map(
        dict => dict.value
      ),
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },
  ]
}
